import type { ProductCatalogResponse } from '../types/api';
import { fetchWithTimeout } from './http';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export async function fetchProductCatalog(): Promise<ProductCatalogResponse> {
  const res = await fetchWithTimeout(`${BASE}/api/v1/products`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<ProductCatalogResponse>;
}
